import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    values = {},
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.config.saveMany, { values }, options);
    if (error) return { error, status };
    return { ...content };
};
